.month-options,
.day-options {
  min-width: 180px;
}
